export default {
    name: {
        invalid: 'El nombre solo puede contener letras',
        required: 'El nombre es obligatorio'
    },
    lastName: {
        invalid: 'El apellido solo puede contener letras',
        required: 'El apellido es obligatorio'
    },
    country: {
        required: 'El pais es obligatorio'
    },
    state: {
        required: 'El departamento es obligatorio'
    },
    city: {
        required: 'La ciudad es obligatoria'
    },
    language: {
        required: 'El lenguaje es obligatorio'
    },
    email: {
        email: 'Dirección de correo electrónico inválida',
        required: 'El correo electrónico es obligatorio'
    },
    password: {
        min: 'La contraseña debe tener al menos {min} caracteres',
        required: 'La contraseña es obligatoria'
    },
    passwordConfirm: {
        match: 'Las contraseñas deben coincidir',
        required: 'La confirmación de la contraseña es obligatoria'
    },
    brand: {
        required: 'La marca comercial es obligatoria'
    },
    economicActivity: {
        required: 'La actividad económica es obligatoria'
    },
    companyCategory: {
        required: 'La categoría de empresa es obligatoria'
    },
    companyType: {
        required: 'El tipo de empresa es obligatorio'
    },
    code: {
        required: 'El código es obligatorio'
    },
    description: {
        required: 'La descripción es obligatoria'
    },
    category: {
        required: 'La categoría es obligatoria'
    },
    subcategory: {
        required: 'La subcategoría es obligatoria'
    },
    severity: {
        required: 'La severidad es obligatoria'
    },
    assetType: {
        required: 'El tipo de activo es obligatorio'
    },
    assetCategory: {
        required: 'La categoría de activo es obligatoria'
    },
    controlAction: {
        required: 'La acción de control es obligatoria'
    },
    selectedImpact: {
        required: 'El o los impactos seleccionados son obligatorios'
    },
    selectedControlDomain: {
        required: 'El dominio de control seleccionado es obligatorio'
    },
    selectedControl: {
        required: 'El control seleccionado es obligatorio'
    },
    responsible: {
        required: 'El responsable es obligatorio'
    },
    creationDate: {
        required: 'La fecha de creación es obligatoria'
    },
    nextFollowUp: {
        required: 'La fecha del próximo seguimiento es obligatoria'
    },
    treatmentActionDescription: {
        required: 'La descripción de la acción de tratamiento es obligatoria',
        maxLength: 'La descripción de la acción de tratamiento no puede exceder los 500 caracteres',
        minLength: 'La descripción de la acción de tratamiento debe ser minimo de 20 caracteres'
    },
    subdomain: {
        required: 'El subdominio es obligatorio',
    },
    assetSecurityRequirements: {
        required: 'La descripción del requerimiento de seguridad es requerida'
    },
    assetImpactAreas: {
        required: 'Los factores de impacto del activo son requeridos'
    },
    organizationalProcess: {
        required: 'Las áreas y procesos organizacionales son obligatorios'
    },
    validityStartDate: {
        required: 'La fecha de inicio de vigencia es obligatoria'
    },
    validityEndDate: {
        required: 'La fecha de fin de vigencia es obligatoria',
        afterStart: 'La fecha de fin debe ser posterior a la de inicio'
    },
    codeRequired: 'El código es obligatorio',
    nameEsRequired: 'El nombre en español es obligatorio',
    nameEnRequired: 'El nombre en inglés es obligatorio',
    priceType: 'El precio debe ser un número',
    priceRequired: 'El precio es obligatorio',
    priceMin: 'El precio no puede ser negativo',
    currencyRequired: 'La moneda es obligatoria',
    billingPeriodRequired: 'El período de facturación es obligatorio'
};